import { Provider } from '@angular/core';

import { ClientDetailsService } from '@client-details/services/client-details.service';
import { CLIENT_DETAILS_STORE } from '@client-details/stores/client-details.store';

export const CLIENT_DETAILS_PROVIDERS: Provider[] = [
  ClientDetailsService,
  CLIENT_DETAILS_STORE
];
